export const FAVORITE_LIST_PREFERENCE_NAME: string = 'favoriteList';
export const MARKET_DATA_QUERY_YEAR_LIMIT: number = 15;
